import dayjs from 'dayjs';
import useCurrentUser from 'src/hooks/useCurrentUser';
import { UIDateFormat } from 'src/lib/constants';

type Props = {
  updatedAt: string;
}

const AdminBar: React.ReactFCWithChildren<Props> = ({ updatedAt, children }) => {
  const [currentUser] = useCurrentUser()

  return currentUser?.isAdmin ? (
    <div className="container-fluid py-2">
      <div className="row">
        <div className="col-md-6">
          <div>Last updated on: {dayjs(updatedAt).format(UIDateFormat)}</div>
        </div>
        <div className="col-md-6 text-md-right">
          {children}
        </div>
      </div>
    </div>
  ) : <></>
}

export default AdminBar
